'use strict';

function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }

var React = require('react');
var React__default = _interopDefault(React);

var types = {
  INITIAL_PAGE_LOAD: '0',
  INDETERMINATE: '1',
  ACCEPTED: '2',
  REJECTED: '3'
};
var gtmContext = React.createContext({
  types: types,
  status: types.INITIAL_PAGE_LOAD,
  trackPageView: function trackPageView() {},
  trackCustomEvent: function trackCustomEvent() {}
});

exports.gtmContext = gtmContext;
exports.types = types;
